export default __webpack_public_path__ + "static/service-flow-bd8897f2de70e395ffabf9d234cb751f.png";